// plop_marker:layouts_import
import MondayIntegrationsConnections from "./monday-integrations-connections/index.js";
import FloatingIntegrations from "./floating-integrations/index.js";
export default {
    // plop_marker:layouts_add_layout
    MondayIntegrationsConnections,
    FloatingIntegrations
};
